import { GlobalHeader } from 'Shared/global-header';
import { onDomReady } from 'Shared/utils/dom-ready';

onDomReady(() => {
   Header.initialize();

   document.querySelectorAll('#menu-button, .search-toggle').forEach(toggle => {
      toggle.addEventListener('click', ev => {
         ev.preventDefault();
         ev.stopPropagation();
         document.querySelectorAll('.mobile-nav').forEach(nav => {
            nav.classList.toggle('expanded');
         });
      });
   });
});

export const Header = new GlobalHeader();

Header.initialize = function () {
   this.setupHeaderDropdown(
      document.querySelector('#profileMenuToggle'),
      document.querySelector('#profileMenuContainer')
   );
};
